import axiosInstance from './axiosInstance';

export interface CreditSummary {
  credit_balance: number;
  low_balance_threshold: number;
  pending_request: {
    id: number;
    status: 'pending' | 'approved' | 'rejected';
    requested_at: string;
  } | null;
}

export interface CreditRequest {
  id: number;
  user_id: number;
  status: 'pending' | 'approved' | 'rejected';
  balance_at_request: number;
  granted_amount: number | null;
  requested_at: string;
  handled_at: string | null;
  username: string;
  email: string;
  nickname: string | null;
  credit_balance: number;
}

export const getMyCredit = async (): Promise<CreditSummary> => {
  const response = await axiosInstance.get('/api/credits/me');
  return response.data;
};

export const requestCredit = async (): Promise<{ success: boolean; id: number; message?: string }> => {
  const response = await axiosInstance.post('/api/credits/request');
  return response.data;
};

export const getPendingCreditRequests = async (): Promise<CreditRequest[]> => {
  const response = await axiosInstance.get('/api/admin/credits/requests');
  return response.data;
};

export const grantCreditRequest = async (id: number, amount: number): Promise<void> => {
  await axiosInstance.post(`/api/admin/credits/requests/${id}/grant`, { amount });
};

export const rejectCreditRequest = async (id: number): Promise<void> => {
  await axiosInstance.post(`/api/admin/credits/requests/${id}/reject`);
};
